import React from "react";
import grievance from "../../assets/images/svg/grievance.svg";

const GrievanceCard = () => {
  return (
    <div className="griv_card_out">
      <div className="email-details-wrapper">
        <h2>Register Your Grievance</h2>
        <div className="link-wrapper">
          <p className="text blueTextColor">
            Escalate the issue or connect with us at{" "}
          </p>
          <p className="space-containt">&nbsp;</p>
          <a
            className="mail-link darkBlueTextColor"
            href="mailto:info.nuvamaprivate@nuvama.com"
          >
            info.nuvamaprivate@nuvama.com
          </a>
        </div>
      </div>
      <img src={grievance} alt="" />
    </div>
  );
};

export default GrievanceCard;
